
export default function Inscripcion() {

    return (
        <div className='row'>
            <embed src={require('./../img/inscripcion.pdf')} type="application/pdf" width="100%" height="600px" />
        </div>
    )

}